import React from "react";
import NotInformation from '../../../../components/NotInformation';
import SearchSimple from "../../../../components/SearchSimples/SearchSimple";
import CopyBuildingLinkModal from "../../Modal/CopyBuildingLinkModal";
import ResidentDetailsModal from "../../Modal/ResidentDetailsModal";
import ResidentAssignedCard from "./ResidentAssignedCard";
import { ResidentsRegisteredApp } from "../../Functionality/ResidentsRegisteredApp";
/**
 * @Author: karen Yunuen Pozos Arias
 * @JobTitle : Full Stack Developer
 * @Email : kpozos@ibl.mx
 *
 * Registered residents of the building detail, searchable card grid with the
 * actions menu of each resident.
 *
 * @param {Object} props.buildingDetail - Building the residents belong to.
 * @param {number} props.refresh - Counter bumped by the add modal to reload the list.
 * @param {Function} props.onTotalChange - Reports the total of the list to the badge of the tab.
 */
const ResidentsRegistered = ({ buildingDetail, refresh, onTotalChange }) => {
    const {
        t,
        option,
        searchElement,
        setSearchElement,
        results,
        setResults,
        rowsPerPage,
        setSearch,
        setSimpleSearch,
        setBodyForExport,
        handleSearch,
        handleResetSearch,
        detailsModal,
        invitationLinkModal,
        setInvitationLinkModal,
        selectedItem,
        setSelectedItem,
        hideDetails,
        getActionsButtons,
        pagination,
        elementRef
    } = ResidentsRegisteredApp({
        buildingId: buildingDetail?.id,
        refresh,
        onTotalChange
    });

    return (
        <>
            <div className="row my-4 flex-shrink-0">
                <div className={"col-12 px-0"}>
                    <SearchSimple
                        id={"txt_rrg_search_simple"}
                        label={'search_by_name_email_or_apartment'}
                        searchElement={searchElement}
                        setSearchElement={setSearchElement}
                        optionTable={option}
                        rowsPerPage={rowsPerPage}
                        setSearchResults={setResults}
                        setBodyForExport={setBodyForExport}
                        setSearch={setSearch}
                        setSimpleSearch={setSimpleSearch}
                        callApi={handleSearch}
                        resetApi={handleResetSearch}
                    />
                </div>
            </div>

            {results?.content?.length > 0 ? (
                <>
                    <div className="panelTables-container custom-scrollbar" ref={elementRef}>
                        <div className="row">
                            {
                                results?.content?.map((resident, index) => (
                                    <div className='col-12 col-md-6 mb-3 px-1' key={resident?.id}>
                                        <ResidentAssignedCard
                                            keyId={'id'}
                                            item={resident}
                                            actions={getActionsButtons(resident, index)}
                                        />
                                    </div>
                                ))
                            }
                        </div>
                    </div>

                    <div className={"flex-shrink-0"}>
                        {pagination()}
                    </div>
                </>)
                : (
                    <NotInformation
                        text={searchElement === "" ? t('you_have_not_registered_any_resident_yet') : t("no_results_found")}
                        card={true}
                        className={"h-100"}
                    />
            )}

            <ResidentDetailsModal
                show={detailsModal}
                onHide={hideDetails}
                item={selectedItem}
            />

            {invitationLinkModal && buildingDetail &&
                <CopyBuildingLinkModal
                    show={invitationLinkModal}
                    setShow={setInvitationLinkModal}
                    itemSelected={buildingDetail}
                    userSelected={selectedItem && {
                        userId: selectedItem?.userId,
                        name: selectedItem?.fullName,
                        apartment: selectedItem?.apartment,
                        buildingApartmentId: selectedItem?.buildingApartmentId || selectedItem?.apartmentId
                    }}
                    setItemSelected={setSelectedItem}
                />
            }
        </>
    );
};

export default ResidentsRegistered;
